"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AIRASIA_MOVE = {
  colors: {
    default: '#FFFFFF',
    primary: '#01EA6B',
    primaryDark: '#12C25A',
    primaryLight: '#FBEBE9',
    secondary: '#023C40',
    secondaryDark: '#4448A0',
    secondaryLight: '#E8F2EC',
    purple: '#4B4FA6',
    purpleLight: '#EDEDF6',
    secondaryBlue: '#4B4FA6',
    tertiary: '#067E41',
    tertiaryDark: '#036835',
    tertiaryLight: '#E6F2EC',
    turquoise: '#0E7EA0',
    orange: '#C94318',
    orangeDark: '#B73810',
    orangeDarkMedium: '#F3693F',
    orangeDarkActive: '#C6472A',
    orangeNeutral: '#D97F00',
    orangeLight: '#FAECE8',
    blue: '#2F73D2',
    blueDark: '#2765BD',
    blueMedium: '#436BA3',
    lightBlue: '#074fa6',
    blueLight: '#EAF1FB',
    blueDarker: '#2F73D2',
    indigoBlue: '#2D3A6F',
    yellow: '#D97F00',
    green: '#067E41',
    greenLight: '#E6F2EC',
    greenDark: '#OCE865',
    neutral: '#212124',
    greyDarker: '#4C4C50',
    darkGrey: '#1C1B1F',
    greyDark: '#75767A',
    greyMediumDark: '#DADADA',
    greyMedium: '#C5C9D0',
    greyMediumLight: '#EBEBEB',
    greyLight: '#D9DBE0',
    greyLighter: '#F8F8F8',
    greyLightest: 'rgba(217, 219, 224, 0.5)',
    gray: '#e5e5e5',
    slateGray: '#D9DBE0',
    black: '#000000',
    pinkLighter: '#FFDEDE',
    oldLace: '#FFF4E5',
    pink: '#B04459',
    tertiaryRed: '#8D1414',
    oldSecondary: '#4B4FA6',
    oldPrimaryDark: '#C92D21',
    primaryGrey: '#DFE1E5',
    primaryRed: '#AD1C29',
    lightRed: '#FAEAEA',
    lightGrey: '#F4F4F4',
    fireRed: '#C82828',
    tertiaryYellow: '#d97f00',
    primaryClassic: '#DC3224',
    charcoalGrey: '#2C2B2F',
    lightGreen: '#0CE865',
    darkGreen: '#023C40',
    sentimentSuccess: 'rgba(21, 123, 62, 1)',
    blueLighter: 'rgba(45, 58, 111, 1)',
    buttonGreen: '#157B3E'
  },
  backgroundColor: {
    default: '#FFFFFF',
    primary: '#F8F8F8',
    secondary: '#212124',
    tertiary: '#C5C9D0',
    tertiaryDark: '#036835',
    tertiaryRed: '#8D1414',
    blueLight: '#EAF1FB',
    blueMedium: '#436BA3',
    blueDarker: '#2F73D2',
    blueDark: '#2765BD',
    charcoalGrey: '#2C2B2F',
    redLight: '#FBEBE9',
    green: '#067E41',
    greenLight: '#E6F2EC',
    yellowLight: '#FFF4E6',
    yellowLighter: '#FFFCF2',
    greyLight: '#EFEFEF',
    greyLighter: '#F8F8F8',
    greyDarker: '#4C4C50',
    greyDark: '#75767A',
    greyMedium: '#C5C9D0',
    greyLine: '#c4c4c4',
    black: '#000000',
    blue: '#023C40',
    softBlue: '#F2F5FC',
    blueActive: '#D9EFFF',
    secondaryBlue: '#023C40',
    secondaryLight: '#E8F2EC',
    oldLace: '#FFF4E5',
    orange: '#C94318',
    oldPrimaryDark: '#C92D21',
    lightBlue: '#074fa6',
    offWhite: '#ECEDEF',
    pink: '#B04459',
    primaryClassic: '#DC3224',
    purple: '#4B4FA6',
    purpleLight: '#EDEDF6',
    gray: '#D0D0D2',
    slateGray: '#D9DBE0',
    lightGreen: '#0CE865',
    darkGreen: '#023C40',
    indigoBlue: '#2D3A6F',
    yellow: '#D97F00',
    sentimentLow: 'rgba(242, 245, 252, 1)'
  },
  fontFamily: {
    default: 'DM Sans',
    secondary: 'Libre Baskerville'
  },
  fontSize: {
    XXSmall: '0.3rem',
    semiXSmall: '0.5rem',
    semiSmall: '0.71rem',
    XSmall: '0.75rem',
    small: '0.875rem',
    normal: '1rem',
    medium: '1.125rem',
    sNormal: '1.01rem',
    titleSmall: '1.25rem',
    titleNormal: '1.5rem',
    titleXNormal: '1.875rem',
    titleMedium: '2rem',
    titleLarge: '3rem',
    titleExtraLarge: '4rem',
    titleXXLarge: '5rem'
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    bold: 500,
    semiLarge: 600,
    large: 700
  },
  space: {
    none: '0px',
    micromini: '1px',
    mini: '2px',
    nano: '3px',
    micro: '4px',
    xxxtiny: '5px',
    xxtiny: '6px',
    xtiny: '7px',
    tiny: '8px',
    xmicro: '-10px',
    xxmicro: '-15px',
    XXXSmall: '10px',
    XXSmall: '11px',
    XSmall: '12px',
    semiSmall: '14px',
    small: '16px',
    medium: '18px',
    normal: '20px',
    standard: '24px',
    extraStandard: '26px',
    semi: '32px',
    semiMedium: '36px',
    semiLarge: '40px',
    semiXLarge: '45px',
    large: '48px',
    XLarge: '64px',
    semiXXLarge: '80px',
    semiXXXLarge: '108px',
    XXLarge: '128px',
    standardXXLarge: '185px',
    extraXXLarge: '170px',
    XXXLarge: '180px',
    extraLarge: '240px',
    XXXXLarge: '360px',
    XXXXXLarge: '686px',
    XXXXXXLarge: '1000px'
  },
  lineHeight: {
    semiSmall: '12px',
    XSmall: '14px',
    XXSmall: '16px',
    small: '18px',
    normal: '20px',
    semiLarge: '21px',
    large: '22px',
    XLarge: '24px',
    XXLarge: '28px',
    titleSmall: '30px',
    titleNormal: '36px',
    titleMedium: '48px',
    titleLarge: '72px',
    normalLarge: '26px'
  },
  borderRadius: {
    none: '0',
    small: '3px',
    normal: '32px',
    Xnormal: '8px',
    medium: '16px',
    large: '40px',
    XLarge: '50px',
    XXnormal: '4px'
  },
  type: 'AIRASIA_MOVE' // this is used to identify the theme

};
var _default = AIRASIA_MOVE;
exports.default = _default;